import { api } from "./api";

/**
 * AW-2C-005 -- the owned call's customer detail.
 *
 * ONE READ, AND IT TAKES NOTHING
 * ------------------------------
 * `GET /telephony/call/lead` accepts no path parameter, no query string
 * and no body. The native lead identity is derived server-side from the
 * authenticated session, the live S1 lease and the durable acquisition
 * obligation -- so there is nothing for this module to send, and no way
 * for a browser to name a customer it was not already entitled to see.
 * That is the whole safety property, and it is structural rather than
 * validated.
 *
 * WHY THIS IS NOT IN `workspaceToolsApi.js`
 * -----------------------------------------
 * That module's own docstring asserts "Every call here is run-scoped".
 * This read is CALL-scoped: it is authorized by the owned call, not by
 * a Script run, and it stays correct in retained Wrap-up where a run
 * may already be finished. Folding it in would make that module's
 * stated contract false to save one file.
 *
 * NO WRITES, NO POLLING
 * ---------------------
 * One read. The caller fetches once per owned-call identity; nothing
 * here retries, schedules or caches, and there is no POST wrapper to
 * add later by accident.
 */

/** The customer on the agent's own owned call, or a refusal. */
export async function getOwnedCallLead() {
  const res = await api.get("/telephony/call/lead");
  return res.data;
}
